<template>
  <div id="china" class="pt" :class="{ h5: this.$store.state.webType === 'h5' }">
    <el-row :span="24" class="page-content">
      <div class="publish_events_box">
        <div class="publish_events_box_title">Publish Events</div>
        <div class="publish_events_box_form">
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="250px"
            class="demo-ruleForm"
          >
            <el-form-item label="Title:" prop="title">
              <el-input v-model="ruleForm.title"></el-input>
            </el-form-item>
            <el-form-item label="Time:" prop="time">
              <el-input v-model="ruleForm.time"></el-input>
            </el-form-item>
            <el-form-item label="Dead Line:" prop="deadLine">
              <el-input v-model="ruleForm.deadLine"></el-input>
            </el-form-item>
            <!-- <el-form-item label="Time:" prop="time">
              <el-date-picker
                style="width: 70%"
                v-model="ruleForm.time"
                type="date"
                placeholder=""
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="Dead Line:" prop="deadLine">
              <el-date-picker
                style="width: 70%"
                v-model="ruleForm.deadLine"
                type="date"
                placeholder=""
              >
              </el-date-picker>
            </el-form-item> -->
            <!-- <el-form-item label="classification:" prop="label">
              <el-select
                v-model="ruleForm.label"
                placeholder=""
                style="width: 100%"
              >
                <el-option label="WFUCA News" value="102"></el-option>
                <el-option label="Other News" value="103"></el-option>
              </el-select>
            </el-form-item> -->

            <el-form-item label="Location:" prop="location">
              <el-input v-model="ruleForm.location"></el-input>
            </el-form-item>
            <el-form-item label="Initiator:" prop="initiator">
              <el-input v-model="ruleForm.initiator"></el-input>
            </el-form-item>

            <el-form-item label="Call for Application：" prop="application">
              <el-input type="textarea" v-model="ruleForm.application"></el-input>
            </el-form-item>
            <el-form-item label="Brief:" prop="brief">
              <el-input type="textarea" v-model="ruleForm.brief"></el-input>
            </el-form-item>
            <!-- <el-form-item label="Background：" prop="backgroundf">
              <el-input
                type="textarea"
                v-model="ruleForm.backgroundf"
              ></el-input>
            </el-form-item>
            <el-form-item label="Objective:" prop="objective">
              <el-input type="textarea" v-model="ruleForm.objective"></el-input>
            </el-form-item>
             <el-form-item label="Plan:" prop="plan">
              <el-input type="textarea" v-model="ruleForm.plan"></el-input>
            </el-form-item> -->
            <el-form-item label="Background：" prop="backgroundf">
              <tinymce
                v-if="open"
                :width="1270"
                :height="300"
                v-model="ruleForm.backgroundf"
                ref="tinymce"
              ></tinymce>
            </el-form-item>
            <el-form-item label="Objective:" prop="objective">
              <tinymce
                v-if="open"
                :width="1270"
                :height="300"
                v-model="ruleForm.objective"
                ref="tinymce"
              ></tinymce>
            </el-form-item>
            <el-form-item label="Plan:" prop="plan">
              <tinymce
                v-if="open"
                :width="1270"
                :height="300"
                v-model="ruleForm.plan"
                ref="tinymce"
              ></tinymce>
            </el-form-item>
            <el-form-item label="Banner:" prop="coverImage">
              <image-upload :limit="1" v-model="ruleForm.coverImage" />
            </el-form-item>
            <el-form-item label="Need to add to the calendar:" prop="isHome">
              <el-radio-group v-model="ruleForm.isHome">
                <el-radio :label="1">Yes</el-radio>
                <el-radio :label="0">No</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="Need online registration or not:" prop="isActivity">
              <el-radio-group v-model="ruleForm.isActivity">
                <el-radio label="Yes">Yes</el-radio>
                <el-radio label="No">No</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              v-if="ruleForm.isActivity === 'Yes'"
              label="Information Needed:"
              prop="activityInformation"
            >
              <el-checkbox-group v-model="ruleForm.activityInformation">
                <el-checkbox label="Name"></el-checkbox>
                <el-checkbox label="Gender"></el-checkbox>
                <el-checkbox label="Country"></el-checkbox>
                <el-checkbox label="E-mail"></el-checkbox>
                <el-checkbox label="Contact Number"></el-checkbox>
                <el-checkbox label="ORG-name"></el-checkbox>
              </el-checkbox-group>
            </el-form-item>

            <el-form-item label="Events Description:" prop="content">
              <tinymce
                v-if="open"
                :width="1270"
                :height="300"
                v-model="ruleForm.content"
                ref="tinymce"
              ></tinymce>
            </el-form-item>
            <el-form-item>
              <el-button class="sub_btn_form" type="primary" @click="submitForm('ruleForm')"
                >Submit</el-button
              >
              <!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-row>
  </div>
</template>

<script>
import Tinymce from "@/components/tinymce";
import ImageUpload from "@/components/ImageUpload";
export default {
  name: "china",
  components: {
    Tinymce,
    ImageUpload,
  },
  data() {
    return {
      uploadList: [],
      gutterWidth: 20,
      open: true,
      ruleForm: {
        title: "",
        label: "",
        country: "",
        coverImage: "",
        brief: "",
        content: "",
        application: "",
        objective: "",
        plan: "",
        isHome: "",
        isActivity: "",
        deadLine: "",
        type: 2,
        activityInformation: [],
      },
      rules: {
        title: [{ required: true, message: "Please input Title", trigger: "blur" }],
        time: [{ required: true, message: "Please input Time", trigger: "blur" }],
        deadLine: [{ required: false, message: "Please input Dead Line", trigger: "blur" }],
        location: [{ required: true, message: "Please input Location", trigger: "blur" }],
        initiator: [{ required: true, message: "Please input Lnitiator", trigger: "blur" }],
        label: [{ required: true, message: "Please choose Classification", trigger: "change" }],
        application: [
          { required: false, message: "Please input Call for Application", trigger: "change" },
        ],
        coverImage: [
          {
            required: true,
            message: "Please upload Banner",
            trigger: "blur",
          },
        ],
        brief: [
          {
            required: false,
            message: "Pleanse input Brief Introduction",
            trigger: "blur",
          },
        ],
        backgroundf: [
          {
            required: false,
            message: "Please input Background",
            trigger: "blur",
          },
        ],
        objective: [
          {
            required: false,
            message: "Please input Objective",
            trigger: "blur",
          },
        ],
        plan: [
          {
            required: false,
            message: "Please input plan",
            trigger: "blur",
          },
        ],
        isHome: [
          {
            required: true,
            message: "Please choose",
            trigger: "blur",
          },
        ],
        isActivity: [
          {
            required: true,
            message: "Please choose",
            trigger: "blur",
          },
        ],
        activityInformation: [
          {
            required: true,
            message: "Please check",
            trigger: "blur",
          },
        ],
        content: [
          {
            required: true,
            message: "Please input Events Description",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    if (this.$route.query.token) {
      sessionStorage.setItem("token", this.$route.query.token);
    }
  },
  beforeUpdate() {
    // this.resetForm("ruleForm");
  },
  methods: {
    editAticle(aId) {
      (this.open = true), this.resetForm("ruleForm");
      this.$get(this.$api + "/un/webarticle/getInfo?aId=" + aId).then((res) => {
        if (res.data.activityInformation == null || res.data.activityInformation[0] == "") {
          res.data.activityInformation = [];
        }
        this.ruleForm = res.data;
      });
    },
    handleBeforeUpload(file) {
      this.fileType = file.name.split(".")[1];
    },
    uploadURL(file) {
      const formData = new FormData();
      formData.append("file", file.file);
      //注意哦，这里指定文件夹'image/'，尝试过写在配置文件，但是各种不行，写在这里就可以
      var fileName = "video/" + "ymy_" + `${Date.parse(new Date())}` + "." + this.fileType;
      let pageName = file.file.name;
      console.log(pageName);
      // this.videoFlag = true;
      let that = this;
      this.$post(this.$api + "/web/common/upload", formData).then((res) => {
        this.ruleForm.coverImage = res.url;
      });
      return;
      //定义唯一的文件名，打印出来的uid其实就是时间戳
      client()
        .multipartUpload(fileName, file.file, {
          headers,
          progress: function (percentage, cpt) {
            console.log("打印进度", percentage);
            console.log(that.videoFlag);
            that.videoUploadPercent = parseInt(percentage * 100);
          },
        })
        .then((res) => {
          console.log(res);
          //此处赋值，是相当于上传成功之后，手动拼接服务器地址和文件名
          this.form.imgUrl = res.res.requestUrls[0].split("?")[0];
          this.uploadList = [{ name: pageName, url: this.form.imgUrl }];
          console.log(this.uploadList);
          this.$message.success("作品上传成功！");
          // 进度条恢复到初始状态
          this.videoFlag = false;
          this.videoUploadPercent = 0;
        });
    },
    handleRemove: function (file, fileList) {
      this.uploadList = [];
    },
    submitForm(formName) {
      this.ruleForm.language = localStorage.getItem("lang");
      this.ruleForm.token = sessionStorage.getItem("tokenPub");
      let data = this.ruleForm;

      this.$refs[formName].validate((valid) => {
        if (valid) {
          let url = "/un/webrelease/addarticle";
          if (this.ruleForm.aId) {
            //修改
            url = "/un/webrelease/edit";
            data.activityInformation = data.activityInformation.join(",");
          }

          this.$post(this.$api + url, data).then((res) => {
            this.$message({
              message:
                this.$store.state.lang == "FR" ? "Soumettre avec succès!" : "Submit Success！",
              type: "success",
            });
            this.resetForm("ruleForm");
            this.open = false;
            this.$emit("handleSubmitList", "");
            // this.$router.push("/publishlist");
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style lang="scss" scoped>
.sub_btn_form {
  background-color: rgba(0, 93, 176, 1);
  border-radius: 35px;
  height: 49px;
  width: 307px;
}

.publish_events_box {
  margin: 0 auto;
  width: 100%;
  color: #333333;
  border-top: 1px solid #e4e4e4;
  .publish_events_box_title {
    font-size: fh(36vh, pc);
    line-height: fh(44vh, pc);
    font-weight: 500;
    white-space: nowrap;
    padding: fh(20vh, pc) 0;
  }
  ::v-deep .publish_events_box_form {
    padding-top: fh(40vh, pc);
    padding-bottom: fh(60vh, pc);
    .el-form-item__label {
      text-align: left;
    }
  }
}
</style>
